import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CounterPartyService {

  constructor(private http: HttpClient) {}

  private makeRequest(url: string, params: Record<string, any>): Observable<any> {
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /** xsivl3 - getEntityDetails */
  getEntityDetails(baseUrl: string, sso_id: string): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, { action_code: 'xsivl3', sso_id });
  }

  /** 9qlq82 - getSourceDetails */
  getSourceDetails(baseUrl: string, sso_id: string): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, { action_code: '9qlq82', sso_id });
  }

  /** kwnh6r - getCountryDetails */
  getCountryDetails(baseUrl: string, sso_id: string): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, { action_code: 'kwnh6r', sso_id });
  }

  /** zxb20a - getCPFormDetails */
  getCPFormDetails(
    baseUrl: string,
    params: {
      sso_id: string;
      combination_key: number | string;
      cp_form_name: string;
      cp_schedule_name: string;
      line_no: string;
      col_id: string;
      form_no: string;
      schedule: string;
      part_no: string;
      sys_acct_selected: number | string;
    }
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, { action_code: 'zxb20a', ...params });
  }

  /** cug2fy - getCPSubFormDetails */
  getCPSubFormDetails(
    baseUrl: string,
    params: {
      sso_id: string;
      combination_key: number | string;
      cp_form_name: string;
      cp_schedule_name: string;
      line_no: string;
      col_id: string;
      form_no: string;
      schedule: string;
      part_no: string;
    }
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, { action_code: 'cug2fy', ...params });
  }

  /** u8rrpy - getPayorDetails */
  getPayorDetails(
    baseUrl: string,
    params: {
      sso_id: string;
      combination_key: number | string;
      form_name: string;
      schedule_name: string;
      classification: string;
      line_no: string;
    }
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, { action_code: 'u8rrpy', ...params });
  }

  /** myu41i - getBSLADetails */
  getBSLADetails(
    baseUrl: string,
    params: {
      sso_id: string;
      combination_key: number | string;
      payor_leid: string;
      payor_cdr_no: string;
      payor_rp_period: string;
    }
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, { action_code: 'myu41i', ...params });
  }

  /** zg307b - getIncomeCategoryDetails */
  getIncomeCategoryDetails(baseUrl: string): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, { action_code: 'zg307b' });
  }

  /** lxged7 - getCPEntityTBAmt */
  getCPEntityTBAmt(
    baseUrl: string,
    params: {
      sso_id: string;
      combination_key: number | string;
      form_name: string;
      schedule: string;
      line_no: string;
      column: string;
    }
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    return this.makeRequest(url, { action_code: 'lxged7', ...params });
  }

  /** w6ug7s - saveCPForm */
  saveCPForm(
    baseUrl: string,
    params: {
      json_data: string;
      json_settings: string;
      process_name: string;
      cp_form_name: string;
      cp_schd_name: string;
      form_selected: string;
      schd_selected: string;
      part_selected: string;
      line_selected: string;
      col_selected: string;
      [key: string]: any;
    }
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=w6ug7s`;
    return this.makeRequest(url, params);
  }
}
